import close from "../../svg/close.webp";

const SidebarLeft = ({ onClose, children, width = "320px" }) => {
  return (
    <>
      <div
        className="position-fixed top-0 start-0 w-100 vh-100 bg-dark bg-opacity-10"
        style={{ backdropFilter: "blur(4px)", zIndex: 1050 }}
        onClick={onClose}
      >
        <div
          className={`position-fixed top-0 start-0 bg-white shadow  ${width}`}
          style={{
            height: "calc(100vh - 30px)",
            margin: "15px 0",
            borderTopRightRadius: "1rem",
            borderBottomRightRadius: "1rem",
            backdropFilter: "blur(16px)",
            overflowY: "auto",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="p-3" role="button" onClick={onClose}>
            <img src={close} width={22} alt="Close" />
          </div>

          <div className="p-4 pt-2">{children}</div>
        </div>
      </div>
    </>
  );
};

export { SidebarLeft };
